import React from 'react';

/**
 * Premium admin empty state — icon + title + helper + optional CTA.
 * Used everywhere we'd otherwise show bare gray text (tables, lists, panels).
 *
 * Props:
 *   icon   — Lucide icon component
 *   title  — short headline (e.g. "No drafts yet")
 *   body   — explanatory copy
 *   action — optional ReactNode (button/link)
 *   testid — root data-testid
 */
export const AdminEmptyState = ({ icon: Icon, title = 'Nothing here yet', body, action, testid }) => {
  return (
    <div className="admin-empty" data-testid={testid || 'admin-empty-state'}>
      {Icon && (
        <div className="admin-empty__icon">
          <Icon className="w-6 h-6" />
        </div>
      )}
      <p className="admin-empty__title">{title}</p>
      {body && <p className="admin-empty__body mt-1">{body}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};

export default AdminEmptyState;
